"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
var react_1 = require("react");
function useOnClickOutside(ref, handleOutdiseClick) {
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handleOutdiseClick();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, handleOutdiseClick]);
}
exports.useOnClickOutside = useOnClickOutside;
